// Game configuration for Kingsomni
export const GAME_CONFIG = {
  // CONTRACT ADDRESSES ON SOMNIA TESTNET
  CONTRACTS: {
    GAME:
      import.meta.env.VITE_GAME_CONTRACT ||
      "0x0000000000000000000000000000000000000000",
    PROFILE:
      import.meta.env.VITE_PROFILE_CONTRACT ||
      "0x0000000000000000000000000000000000000000",
    TREASURY:
      import.meta.env.VITE_TREASURY_CONTRACT ||
      "0x0000000000000000000000000000000000000000",
    LEADERBOARD:
      import.meta.env.VITE_LEADERBOARD_CONTRACT ||
      "0x0000000000000000000000000000000000000000",
  },
  API: {
    BACKEND_URL: import.meta.env.VITE_BACKEND_API_URL || "http://localhost:3001",
  },

  // ECONOMY SETTINGS (Match Smart Contract)
  ECONOMY: {
    BASE_UPGRADE_COST: 0.05, // 0.05 STT
    UNLOCK_SKILL_COST: 0.1, // 0.1 STT
    BOUNTY_PERCENTAGE: 10, // 10% from upgrades
  },

  // Game settings
  GAME_DURATION: 90 * 1000,
  CANVAS: {
    WIDTH: 1200,
    HEIGHT: 620,
  },

  // Player settings
  PLAYER: {
    SPEED: 5,
    SIZE: 30,
    HEALTH: 100,
    FIRE_RATE: 150,
  },

  // Enemy settings
  ENEMY: {
    SPEED: 2,
    SIZE: 25,
    SPAWN_RATE: 0.02,
    HEALTH: 1,
  },

  // Wave settings
  WAVES: {
    INTERVAL: 10000,
    SPAWN_MULTIPLIER: 1.2,
    SPEED_MULTIPLIER: 1.1,
  },

  // Bullet settings
  BULLET: {
    SPEED: 7,
    SIZE: 4,
    DAMAGE: 1,
  },

  // Skill settings
  SKILLS: {
    FREEZE: { DURATION: 2500, COOLDOWN: 18000 },
    HEAL: { AMOUNT: 25, COOLDOWN: 25000 },
    DAMAGE_BOOST: { MULTIPLIER: 2, DURATION: 5000, COOLDOWN: 30000 },
  },

  // Score settings
  SCORE: {
    PER_KILL: 10,
    COMBO_MULTIPLIER: 1.5,
    COMBO_TIMEOUT: 3000,
  },

  // Submission settings
  SCORE_SUBMISSION: {
    MAX_CPS: 8,
    MIN_DURATION: 5000,
    MAX_DURATION: 300000,
  },

  // Game metadata
  METADATA: {
    name: "Kingsomni",
    url: import.meta.env.VITE_VERCEL_URL || "http://localhost:5173",
    image: "https://kingsomni.vercel.app/banner.png",
  },
} as const;

export const SOMNIA_CHAIN_ID = 50312;
